module.exports = __webpack_public_path__ + "img/SignInNow.9913aa9b.png";